import HomePage from './HomePage.vue';

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/home'
  // },
  {
    path: '/home',
    name: 'home',
    component: HomePage,
    meta: {
      title: 'Accueil',
      requiresAuth: true
    }
  }
];

export default routes;
